export const defaultIdCard = {
  id: '',
  name: '',
  tagId: '',
  description: '',
  characteristics: {},
  totalWeightDry: '',
  length: '',
  width: '',
  height: '',
  images: [
    {
      imageId: null,
      legend: '',
      indexNr: 0,
    },
    {
      imageId: null,
      legend: '',
      indexNr: 1,
    },
    {
      imageId: null,
      legend: '',
      indexNr: 2,
    },
    {
      imageId: null,
      legend: '',
      indexNr: 3,
    },
    {
      imageId: null,
      legend: '',
      indexNr: 4,
    },
    {
      imageId: null,
      legend: '',
      indexNr: 5,
    },
    {
      imageId: null,
      legend: '',
      indexNr: 6,
    },
    {
      imageId: null,
      legend: '',
      indexNr: 7,
    },
    {
      imageId: null,
      legend: '',
      indexNr: 8,
    },
    {
      imageId: null,
      legend: '',
      indexNr: 9,
    },
  ],
  weightStructure: '',
  weightMechanical: '',
  weightPiping: '',
  weightElectrical: '',
  weightInstrument: '',
  totalWeightFluids: '',
  totalWeightOperating: '',
  liftingLugs: '',
  liftingPosition: '',
  tieIns: [],
  equipmentList: [],
  documents: [],
  remainingScopeImageId: '',
  projectUtil: [],
  otherDocuments: [],
  otherSimilarIdCards: [],
  resNotes: [],
  deploymentArea: '',
  designMaturity: '',
  designMaturityImageId: '',
  family: null,
  familyId: '',
  integratedPiperack: true,
  previousVersionId: '',
  revision: '',
  safety: '',
  supporting: '',
  tieInsOtherNetworks: '',
  tieInsOtherUtilities: '',
  version: '',
  secondarySystem: null,
};
